/**
 * this component will display the card summary information
 *
 * @module views/components/SummaryCard
 * @memberof -Common
 */
import './SummaryCard.scss';

import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Text as PalText } from 'web-palette/dist/components/Text/Text';

import Icon from '@ulta/core/components/Icon/Icon';
import Text from '@ulta/core/components/Text/Text';

import { ClickableBadge } from '@ulta/components/ClickableBadge/ClickableBadge';



/**
 * Represents a SummaryCard component
 *
 * @method
 * @param {SummaryCardProps} props - React properties passed from composition
 * @returns SummaryCard
 */
export const SummaryCard = function( props ){
  const { type, icon, title, subTitle, items, layout, onItemSelection } = props;

  const summaryItem = ( item, index ) => (
    <React.Fragment key={ index }>
      { (
        <li
          className={ classNames( 'SummaryCard--listItem', {
            'SummaryCard--listItem--halfWidth': type === summaryCardVarinats.HALF
          } ) }
        >
          <ClickableBadge item={ item }
            onClick={ () => onItemSelection( item.itemDetailCard ) }
          />
        </li>
      ) }
    </React.Fragment>
  );



  return (
    <div className='SummaryCard'>
      <div>
        { icon && (
          <Icon
            size='l'
            name={ icon }
            className='SummaryCard--titleIcon'
            aria-hidden={ true }
          />
        ) }
      </div>
      <div>
        { title && (
          <PalText htmlTag='h2'
            textStyle='title-sm'
          >
            { title }
          </PalText>
        ) }
        { subTitle && (
          <Text textStyle='body-sm'
            color='neutral-500'
          >
            { subTitle }
          </Text>
        ) }
        <ul className={ classNames( 'SummaryCard--listWrapper', {
          ...( layout && { [`SummaryCard--${layout}`]: layout } )
        } )
        }
        >
          { items && items.length && items.map( ( item, index )=>(
            summaryItem( item, index )
          ) ) }
        </ul>
      </div>
    </div>
  );
};

export const summaryCardVarinats = {
  HALF : 'Half',
  FULL : 'Full'
};

/**
 * Property type definitions
 * @typedef SummaryCardProps
 * @type {object}
 * @property {string} type - Sets value for the type
 * @property {string} icon - Sets value for an icon
 * @property {string} title - Sets value for the title
 * @property {object} items - Array of items required for summary card
 * @property {string} layout - Sets value for the layout
 */
export const propTypes =  {
  type: PropTypes.oneOf( ['Full', 'Half'] ),
  icon: PropTypes.string,
  title: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape( {
      icon: PropTypes.string,
      label: PropTypes.string
    } )
  ),
  layout: PropTypes.string.isRequired
};

SummaryCard.propTypes = propTypes;

export default SummaryCard;